// extracted by mini-css-extract-plugin
export default {"div":"Password_div__w8TWH","headline":"Password_headline__zevsw","input":"Password_input__g9ju2"};